import React from "react"
import { getType, isWideLoad, getSafeDataMap } from "@jsUtils/contentful"
import { ContentRow, ContentItem } from "@shared"
import resolveComponent from "./resolveComponent"
import Styles from "./renderer.module.scss"

/**
 * Helper
 * Render a row of content by iterating over the content collection
 * @param {object} props - react props
 * @param {array} data - content array from page
 */
const MultiContentRenderer = ({ data }) => {
  return getSafeDataMap(data, module => {
    // strings from shared/contentgrid/contentgrid.module.scss
    const gridAreaType = isWideLoad(module) ? "pageSection" : "article"
    return (
      <ContentRow key={module.id || Math.random()}>
        <ContentItem gridArea={gridAreaType} extraClass={Styles[getType(module)]}>
          {resolveComponent(module)}
        </ContentItem>
      </ContentRow>
    )
  })
}

export default MultiContentRenderer
